export default {
  basicData: {
    lastName: '八木',
    firstName: '太郎',
    lastNameFurigana: 'やぎ',
    firstNameFurigana: 'たろう',
    birthYear: '2002',
    birthMonth: '5',
    birthDay: '8',
    sex: '1',
    postNumber: '1040040',
    address1: '東京都中央区築地4',
    address2: '白山羊ビル3F',
    addressFurigana: 'とうきょうと ちゅうおうく つきじ',
    tel1: '03',
    tel2: '5148',
    tel3: '1212',
    mobile: '',
    fax: '',
    email: 'taro_yagi@yagish.jp',
    idPhotoSrc: '/static/img/id-photo-sample.jpg',
    useContact: [''],
    contactPostNumber: '',
    contactAddress1: '',
    contactAddress2: '',
    contactAddressFurigana: '',
    contactCareOf: '',
    contactTel: '',
    contactMobile: '',
    contactFax: '',
    contactEmail: '',
    updateDate: ''
  },
  formatData: {
    createDate: new Date(),
    formatId: 'rirekisho',
    saveName: 'rirekisho',
    educationalHistories: [
      {
        year: 2013,
        month: 2,
        description: 'XX中学校　卒業',
        uuid: '4005e384-8ce0-405b-b0f1-dea47be1a4cb'
      },
      {
        year: 2013,
        month: 3,
        description: 'XX高等学校　入学',
        uuid: 'e193e07f-1cf2-4930-bd52-1065f88c2c4e'
      },
      {
        year: 2016,
        month: 2,
        description: 'XX高等学校　卒業',
        uuid: '108c84e3-ae50-40e7-90f5-0becc48785b4'
      },
      {
        year: 2016,
        month: 3,
        description: 'XX大学校　入学',
        uuid: 'ef19cdf2-34f2-4076-a4bd-3381841cf987'
      },
      {
        year: 2022,
        month: 2,
        description: 'XX大学校　卒業',
        uuid: '99a44d4a-73c6-4440-8247-7bf14ec960bd'
      }
    ],
    licenseHistories: [
      {
        year: '2013',
        month: '4',
        description: '普通自動車第一種運転免許（AT限定）取得',
        uuid: 'a2e09439-2c36-4981-a643-2b0f7adab257'
      },
      {
        year: '2014',
        month: '6',
        description: 'ファイナンシャルプランナーX級合格',
        uuid: 'd6d648f8-30dd-4c09-9367-036416723c1c'
      }
    ],
    commuteHours: '0',
    commuteMinutes: '40',
    commuteDescription: '자차소유',
    spouseNumber: '0',
    hasSpouse: false,
    underDutyToSupport: false,
    mypr: '実際に業務を体験してみて、作成した資料が分かりにくいと指摘を受けることがありました。どうすれば分かりやすい資料を作成できるか繰り返し試みました。自分にとって社会へ出た際の大きな課題であると気付く機会となり、自身が成長できる可能性を感じました。私の長所は、コツコツと仕事を続けられる、継続力があるところです。大学で所属していたXXサークルの合宿は、部員全員の意見をまとめ、決定しています。私は100人以上いる部員の意見をまとめるために、アンケートを作成し、意見を聞き、集計していました。スケジュール管理も大変でしたが、全員の意見をまとめることがとても大変でした。この経験から、継続的な仕事を続けることができると考えております。',
    request: '협의후결정',
    updateDate: '',
    hobbies: [
      {
        id: 0,
        name: 'スポーツ・運動'
      },
      {
        id: 1,
        name: '料理'
      },
      {
        id: 11,
        name: 'マラソン'
      },
      {
        id: 10,
        name: '資格'
      },
      {
        id: 12,
        name: 'カフェ巡り'
      },
      {
        id: 13,
        name: 'プログラミング'
      },
      {
        id: 3,
        name: '映画鑑賞'
      },
      {
        id: 2,
        name: '音楽・ライブ鑑賞'
      },
      {
        id: 14,
        name: '書道'
      }
    ],
    job_category: '不動産営業',
    skills: [
      {
        year: '',
        month: '',
        description: 'Node.js',
        uuid: '2678a2a1-7ae6-42b9-a2d2-cb53cce595f9',
        skill_level: 4
      },
      {
        year: '',
        month: '',
        description: 'Java',
        uuid: 'd3232191-e857-4247-939a-b21a1471f172',
        skill_level: 3
      },
      {
        year: '',
        month: '',
        description: 'MSオフィス',
        uuid: 'ba89d636-df61-4192-99a8-5d15515b09d0',
        skill_level: 2
      }
    ],
    jobDetailHistories: [
      {
        companyName: '株式会社Yagish',
        startYear: '2020',
        startMonth: '1',
        endYear: '2022',
        endMonth: '12',
        isContinuing: false,
        capitalStock: '',
        numberOfEmployees: '',
        businessArea: '',
        projects: [
          {
            projectTitle: '求職者支援プロジェクト',
            startYear: '2020',
            startMonth: '1',
            endYear: '2021',
            endMonth: '10',
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: '7842a12f-cf41-401d-8a76-99b60e157837'
          },
          {
            projectTitle: '求人会社特別募集',
            startYear: '2021',
            startMonth: '12',
            endYear: 2022,
            endMonth: 12,
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: '7285167e-1ac3-48b7-9250-b0beb8cb52e4'
          },
          {
            projectTitle: 'ヤギオファーリリース',
            startYear: 2020,
            startMonth: 1,
            endYear: 2022,
            endMonth: 12,
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: 'ee41decb-b768-4ab3-83bc-cdd3cb4388a4'
          }
        ],
        uuid: 'eba8a4eb-3345-413d-9161-0f5d0a8747c9',
        description: '職歴だと',
        year: '2000',
        month: '12'
      },
      {
        companyName: '株式会社ヤギオファー',
        startYear: '2020',
        startMonth: '1',
        endYear: '2022',
        endMonth: '12',
        isContinuing: false,
        capitalStock: '',
        numberOfEmployees: '',
        businessArea: '',
        projects: [
          {
            projectTitle: '要件整理',
            startYear: '2020',
            startMonth: '1',
            endYear: '2021',
            endMonth: '10',
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: '7842a12f-cf41-401d-8a76-99b60e157837'
          },
          {
            projectTitle: 'テスト&リリース',
            startYear: 2020,
            startMonth: 1,
            endYear: 2022,
            endMonth: 12,
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: 'ee41decb-b768-4ab3-83bc-cdd3cb4388a4'
          }
        ],
        uuid: 'eba8a4eb-3345-413d-9161-0f5d0a8747c9',
        description: '職歴だと',
        year: '2000',
        month: '12'
      },
      {
        companyName: '株式会社ヤギワークス',
        startYear: '2020',
        startMonth: '1',
        endYear: '2022',
        endMonth: '12',
        isContinuing: false,
        capitalStock: '',
        numberOfEmployees: '',
        businessArea: '',
        projects: [
          {
            projectTitle: '勤怠管理プロジェクト',
            startYear: '2020',
            startMonth: '1',
            endYear: '2021',
            endMonth: '10',
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: '7842a12f-cf41-401d-8a76-99b60e157837'
          },
          {
            projectTitle: 'ワークフロープロジェクト',
            startYear: '2021',
            startMonth: '12',
            endYear: 2022,
            endMonth: 12,
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: '7285167e-1ac3-48b7-9250-b0beb8cb52e4'
          },
          {
            projectTitle: '機能改善・維持保守',
            startYear: 2020,
            startMonth: 1,
            endYear: 2022,
            endMonth: 12,
            contentsOfProject: '',
            envAndScale: '',
            position: '',
            uuid: 'ee41decb-b768-4ab3-83bc-cdd3cb4388a4'
          }
        ],
        uuid: 'eba8a4eb-3345-413d-9161-0f5d0a8747c9',
        description: '職歴だと',
        year: '2000',
        month: '12'
      }
    ]
  }
}
